export class RutFormatter {
  static pointAndDash(value) {
    const [num, checkDigit] = value.split('-');
    const stack = ['-', checkDigit];
    for (let i = 0; i < num.length; i += 1) {
      if (i !== 0 && i % 3 === 0) {
        stack.unshift('.');
      }
      stack.unshift(num.charAt(num.length - 1 - i));
    }
    return stack.join('');
  }
}
